/* unplugin-vue-components disabled */import script from "./TravelPrice.vue?vue&type=script&setup=true&lang=jsx"
export * from "./TravelPrice.vue?vue&type=script&setup=true&lang=jsx"

import "./TravelPrice.vue?vue&type=style&index=0&id=42ebd2c4&lang=scss&scoped=true"

import exportComponent from "/Users/fubeibei/TRAE_workspace/cuiwei_xcxsc/cw/travel-manage/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-42ebd2c4"]])

export default __exports__